import React, { Component } from 'react';
import { object } from 'prop-types';
import { inject } from 'mobx-react';

import NotificationModalLayout from '../notification-modal-layout';

class GenericErrorModal extends Component {
  static propTypes = {
    navigation: object.isRequired,
    appConfig: object.isRequired,
    biLogger: object.isRequired,
    view: object.isRequired,
    biData: object,
  };

  biData = {
    ...this.props.biData,
    modalType: 'error',
  };

  handleOpened = () => this.props.biLogger.integrationModalView(this.biData);

  handleClosed = () => this.props.biLogger.integrationModalClosed(this.biData);

  handlePrimaryButtonClick = () => {
    this.props.biLogger.integrationModalCtaClick({
      ...this.biData,
      ctaType: 'close',
    });
    this.props.view.closeModal();
  };

  handleXClick = () => {
    this.props.biLogger.integrationModalCloseViaCloseBar(this.biData);
    this.props.view.closeModal();
  };

  render() {
    const {
      appConfig: { staticsBaseUrl },
    } = this.props;
    return (
      <div data-hook="mi-error-modal">
        <NotificationModalLayout
          illustration={
            <img
              src={`${staticsBaseUrl}assets/illustrations/error-illustration.png`}
              alt=""
            />
          }
          title="generic.dialog.error.modal.title"
          subTitle="generic.dialog.error.modal.sub.title"
          primaryButtonLabel="generic.dialog.error.modal.cta"
          onPrimaryButtonClick={this.handlePrimaryButtonClick}
          onXClick={this.handleXClick}
          footerSize="small"
          isErrorNotification
          onOpened={this.handleOpened}
          onClosed={this.handleClosed}
        />
      </div>
    );
  }
}

export default inject(
  'navigation',
  'appConfig',
  'biLogger',
  'view',
)(GenericErrorModal);
